import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import { useCountry } from '../../context/CountryContext';
import FollowupFloatingPanel from '../Common/FollowupFloatingPanel';

const Layout = ({ children }) => {
  const { activeCountry } = useCountry();
  const [sidebarHover, setSidebarHover] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const collapsed = !sidebarHover;

  // Close mobile sidebar on route changes or resize
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setMobileOpen(false);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleMobile = () => {
    setMobileOpen(!mobileOpen);
  };

  const closeMobile = () => {
    setMobileOpen(false);
  };

  return (
    <div className="app-layout">
      {/* Mobile overlay */}
      <div
        className={`sidebar-overlay ${mobileOpen ? 'active' : ''}`}
        onClick={closeMobile}
      />
      <Sidebar
        collapsed={collapsed}
        mobileOpen={mobileOpen}
        closeMobile={closeMobile}
        onHoverChange={setSidebarHover}
      />
      <Header
        collapsed={collapsed}
        onMobileMenuToggle={toggleMobile}
      />
      <div className={`main-content ${collapsed ? 'collapsed' : ''}`}>
        <div className="page-container">
          {React.isValidElement(children)
            ? React.cloneElement(children, { key: String(activeCountry) })
            : children}
        </div>
      </div>
      <FollowupFloatingPanel />
    </div>
  );
};

export default Layout;
